import React from 'react';
import '../SideBarContainer.scss';
import { string } from '../../../localization';
import './UploadTemplate.scss';

class UploadMoreTemplate extends React.PureComponent {
  render() {
    const { header, mappingArray, closeDrawer, onclick, tags } = this.props;
    return (
      <>
        <div
          id='upload-pane'
          className='flex-grow-1 content-box theme-wrapper-upload '
        >
          <div>
            <button
              type='button'
              className='insta-back-btn-section'
              onClick={() => closeDrawer()}
            >
              <img
                alt='back-icon'
                src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAXCAYAAAGnofUXAAAABGdBTUEAALGPC/xhBQAAAItJREFUOBHdUEEKgDAMm/5kF7/hzwT/6x9mW8woaxx6UFBB65I0aZdS/yml5CSfWWVj0IKpknMFGHPUA+3tRDgDmwZnq2pWDcFcB9GhlXZ5ARMNreAQZYYbJjFLIAXcXgElJF61T6aTQPAcGa8Emb5K/qwzaPU4/f+iWBeRuVd5J7pUD7y1cGv0k+YdnvjcLNGBaDEAAAAASUVORK5CYII='
              />
              <span className='insta-back-txt'>{string.BACK_KEY}</span>
            </button>
            <div className='horizontal-line' style={{ marginTop: '5px' }}>
              <hr />
            </div>
            <div className='insta-header'>{header} </div>
            {mappingArray.length > 7 ? (
              <div className=' theme-wrapper theme-wrapper-scroll-bar more-load-indicator-height'>
                {mappingArray.map((item, index) => (
                  <button
                    type='button'
                    className='folder-list-element-upload'
                    // key={item.mediaId}
                    style={{
                      backgroundImage: `url(${item.thumbnailPath})`,
                      width: '59px',
                      height: '59px'
                    }}
                    onClick={() => onclick(item)}
                  >
                    {header === '' ? (
                      <text className='folder-label-tag'>
                        {` ${tags[index]} `}
                      </text>
                    ) : null}
                  </button>
                ))}
              </div>
            ) : null}
          </div>
        </div>
      </>
    );
  }
}

export default UploadMoreTemplate;
